Ext.define('SA.data.DmaLocations', {
    singleton: true,

    async loadAll() {
        var query = SA.data.Query.from({
            type: 'locations',
            fields: SA.data.LocationsCache.getQueryFields(),
            where: ['=', 'geographicUnit', 'usa:dma'],
            limit: 10000,
            sort: [['asc', 'name']]
        });

        await query.run();

        SA.data.LocationsCache.add(query.response);

        this.all = query.response.map(dma => SA.data.LocationsCache.canonicalize(dma));
    }
});